import React from 'react';
import ReactDOM from 'react-dom/client';
import "slick-carousel/slick/slick.css";
import './index.css';
import App from './App';
import { PostHogProvider } from 'posthog-js/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={{
        api_host: "https://us.i.posthog.com",
        debug: process.env.NODE_ENV === "development",
      }}
    >

      <App />
      
    </PostHogProvider>
  </React.StrictMode>
);
